// The ONE money text field (R-F): same look as TextInput/AmountInput, onChange always receives the sanitized value in e.target.value (max 2 decimals).
import React from 'react';
import { TextInput } from './inputs/Input';
import { sanitizeMoney } from './sanitizeMoney.mjs';

export default function MoneyTextInput({ onChange, className, ...p }) {
  return <TextInput {...p} type="text" inputMode="decimal" autoComplete="off" className={['amt', className].filter(Boolean).join(' ')}
    onChange={e => { const v = sanitizeMoney(e.target.value); if (e.target.value !== v) e.target.value = v; onChange && onChange(e); }} />;
}
